import { Helmet } from "react-helmet-async";
import Hero from "@/components/Hero";
import StorySection from "@/components/StorySection";
import CategoriesSection from "@/components/CategoriesSection";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import React from "react";

const CraftOfTheMonth = React.lazy(() => import("@/components/CraftOfTheMonth"));
const FeaturedProducts = React.lazy(() => import("@/components/FeaturedProducts"));
const FeaturedArtisans = React.lazy(() =>
  import("@/components/FeaturedArtisans").then(({ FeaturedArtisans }) => ({ default: FeaturedArtisans }))
);
import Testimonials from "@/components/Testimonials";
const Newsletter = React.lazy(() => import("@/components/Newsletter"));
const GiftingPreview = React.lazy(() => import("@/components/GiftingPreview"));

const Index = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Store",
        "name": "Gaonova",
        "url": "https://gaonova.com",
        "logo": "https://gaonova.com/logo.png",
        "image": "https://gaonova.com/og-image.jpg",
        "description": "Authentic handcrafted products from rural Indian artisans. Support village communities with every purchase.",
        "telephone": "+911234567890",
        "priceRange": "₹₹",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Rural Artisan Hub",
          "addressLocality": "Kolkata",
          "addressRegion": "West Bengal",
          "postalCode": "700001",
          "addressCountry": "IN"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "contactType": "customer service",
          "telephone": "+911234567890",
          "availableLanguage": ["English", "Hindi"]
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            "opens": "09:00",
            "closes": "20:00"
          }
        ]
      },
      {
        "@type": "WebSite",
        "name": "Gaonova",
        "url": "https://gaonova.com",
        "potentialAction": {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": "https://gaonova.com/shop?search={search_term_string}"
          },
          "query-input": "required name=search_term_string"
        }
      }
    ]
  };

  return (
    <>
      <Helmet>
        <title>Gaonova — Crafts that Carry Centuries</title>
        <meta name="description" content="Discover living craft traditions of rural India — Madhubani, Warli, Dhokra, Terracotta. Meet the artisans, learn the stories, bring the heritage home." />
        <meta name="keywords" content="Indian handicrafts, artisan stories, Madhubani, Warli, Dhokra, terracotta, block print, rural craftsmanship, cultural heritage" />
        <meta property="og:title" content="Gaonova — Crafts that Carry Centuries" />
        <meta property="og:description" content="Living traditions from the villages of India. Meet the makers behind every piece." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://gaonova.com" />
        <script type="application/ld+json">
          {`
            ${JSON.stringify(structuredData)}
          `}
        </script>
      </Helmet>

      <div className="min-h-screen">
        <main id="main-content">
          <Hero />
          <StorySection />
          <React.Suspense fallback={<div className="w-full h-64 flex items-center justify-center"><p>Loading content...</p></div>}>
            <CraftOfTheMonth />
            <FeaturedArtisans />
            <GiftingPreview />
            <CategoriesSection />
            <FeaturedProducts />
            <Testimonials />
            <Newsletter />
          </React.Suspense>
        </main>

        <Footer />
        <BackToTop />
        <WhatsAppButton variant="floating" />
      </div>
    </>
  );
};

export default Index;
